export default {
	methods: {
		buildServiceInvoiceObjectRecordsFromTemplate(selectedTemplateToCopy, invoiceRecordId) {
			if (!selectedTemplateToCopy || !selectedTemplateToCopy.ServiceQuoteTemplateObject)
				return []

			return selectedTemplateToCopy.ServiceQuoteTemplateObject.map(templateItem => {
				let type = ""
				let fieldValues

				if ("Material" in templateItem && templateItem.Material) {
					type = "Material"
					fieldValues = {
						qty: templateItem.qty,
						part_number: templateItem.Material.part_number,
						description: templateItem.Material.description,
						price: templateItem.Material.material_price,
						per: templateItem.Material.per,
						labour_hrs: templateItem.Material.labour_hrs
					}
				}
				else if ("EquipmentType" in templateItem && templateItem.EquipmentType) {
					type = "Equipment"

					let rate = +templateItem.EquipmentType.charge_out_rate

					if ("charge_out_rates_json" in templateItem.EquipmentType && templateItem.EquipmentType.charge_out_rates_json) {

						try {
							let multiRates = JSON.parse(templateItem.EquipmentType.charge_out_rates_json)

							if (templateItem.unit in multiRates && multiRates[templateItem.unit].enabled)
								rate = multiRates[templateItem.unit].rate
						}
						catch (e) {}
					}

					let total = +templateItem.qty * +rate

					fieldValues = {
						typeName: templateItem.EquipmentType.name,
						equipment_type_id: templateItem.EquipmentType.id,
						rate,
						qty: templateItem.qty,
						unit: templateItem.unit,
						total: total.toFixed(2)
					}
				}
				else if ("ClassificationGroup" in templateItem && templateItem.ClassificationGroup) {
					type = "Labour"

					let total = +templateItem.qty * +templateItem.ClassificationGroup.charge_out_rate

					fieldValues = {
						hrs: templateItem.qty,
						rate: templateItem.ClassificationGroup.charge_out_rate,
						crew: 1,
						chargeOutGroupName: templateItem.ClassificationGroup.label,
						group_id: templateItem.ClassificationGroup.id,
						lineTotal: total.toCurrency(2)
					}
				}

				return {
					invoice_id: invoiceRecordId,
					type,
					field_values_json: JSON.stringify(fieldValues)
				}
			}).filter(templateRow => templateRow.type && templateRow.field_values_json)
		}
	}
}
